import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import useSMS from './useSMS';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const SMSContainter: React.FC = () => {
    const { arr, obj, coord } = useSMS();
    delete arr['x'];
    delete arr['y'];
    
    return (
        <>
            <Typography className="device-info__title__sms" variant="h6">
                        СОСТОЯНИЕ УСТРОЙСТВА
            </Typography>
            <Box className="sms-info__wrap">
                <Box className="device-info-sms">                    
                    <Box className="device-info__table-wrap-sms">
                    <Table className="device-info__table" size="small" style={{backgroundColor: 'white'}}>                            
                        <TableBody className="device-info__table">
                                        {Object.keys(arr).map((p,key) => ( 
                                            <TableRow className="device-info__table-row"> 
                                                <TableCell className="device-info__table-cell__sms" key={p}> 
                                                <h3>
                                                    {obj[p]}:
                                                </h3>                                         
                                                <p>         
                                                    {arr?.[p]}
                                                </p>
                                                </TableCell>  
                                            </TableRow>
                                        ))}
                                        <TableRow className="device-info__table-row">
                                        <TableCell className="device-info__table-cell__smss">
                                            <a href={`http://maps.google.com/maps?f=&q=${coord?.['latitude']}+${coord?.['longitude']}&hl=ru`} style={{textDecoration:'none'}}>
                                            <div className='device-info__title-img-gm'></div>                                    
                                            <h3 className='device-info__title-h'>На карту Google</h3>   
                                            <p className="device-info__table-р">
                                                Точное местоположение
                                            </p>                        
                                            </a>
                                        </TableCell>
                                        </TableRow>
                                                                                    
                                        <TableRow className="device-info__table-row">
                                        <TableCell className="device-info__table-cell__smss">                            
                                            <a href={`http://m.maps.yandex.ru/?l=maps&ll=${coord?.['longitude']},${coord?.['latitude']}&pt=${coord?.['longitude']},${coord?.['latitude']}&z=13`} style={{textDecoration:'none'}}>
                                            <div className="device-info__title-img-ym"></div>  
                                            <h3 className="device-info__title-h">На карту Yandex</h3>   
                                                <p className="device-info__title-p">
                                                Точное местоположение
                                                </p>                        
                                            </a>                                 
                                        </TableCell>
                                        </TableRow>
                        </TableBody>                    
                    </Table>
                    </Box>                   
                </Box>                
            </Box>                              
        </>
    );
};

export default SMSContainter;